import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'cambersTag',
  title: 'Camber Tag',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (Rule) => Rule.required(),
      description: 'Internal identifier for the camber tag',
    }),
    defineField({
      name: 'displayName',
      title: 'Display Name',
      type: 'string',
      validation: (Rule) => Rule.required().max(25),
      description: 'Name displayed on fitment listings (max 25 characters)',
    }),
    defineField({
      name: 'filterName',
      title: 'Filter Name',
      type: 'string',
      validation: (Rule) => Rule.max(25),
      description:
        'Name shown in fitment guide filter dropdowns (max 25 characters)',
    }),
    defineField({
      name: 'frontCamberDescription',
      title: 'Front Camber Description',
      type: 'text',
      description:
        'Description for front camber. Available merge fields: {{frontCamber}}, {{rearCamber}}, {{frontCamberReason}}, {{rearCamberReason}}',
    }),
    defineField({
      name: 'rearCamberDescription',
      title: 'Rear Camber Description',
      type: 'text',
      description:
        'Description for rear camber. Available merge fields: {{frontCamber}}, {{rearCamber}}, {{frontCamberReason}}, {{rearCamberReason}}',
    }),
    defineField({
      name: 'squareFitDescription',
      title: 'Front&Rear Camber Description',
      type: 'text',
      description:
        'Description when front and rear camber are the same. Available merge fields: {{frontCamber}}, {{rearCamber}}, {{frontCamberReason}}, {{rearCamberReason}}',
    }),
    defineField({
      name: 'warning',
      title: 'Warning',
      type: 'text',
      description:
        'Warning message displayed with camber information. Uses data from recommended tire size. Available merge fields: {{frontCamber}}, {{rearCamber}}, {{frontCamberReason}}, {{rearCamberReason}}',
    }),
    defineField({
      name: 'isFilterable',
      title: 'Filterable',
      type: 'boolean',
      initialValue: true,
      description: 'Show this tag in fitment guide filters',
    }),
    defineField({
      name: 'isModification',
      title: 'Is Modification',
      type: 'boolean',
      initialValue: true,
      description: 'Show under "Acceptable Modifications" section in filters',
    }),
    defineField({
      name: 'isHidden',
      title: 'Hidden',
      type: 'boolean',
      initialValue: false,
      description:
        'Hide the tag label from the UI while still showing the description',
    }),
    defineField({
      name: 'order',
      title: 'Order',
      type: 'number',
      description: 'Display order in filters (lower numbers appear first)',
    }),
    defineField({
      name: 'penaltyScore',
      title: 'Penalty Score',
      type: 'number',
      description:
        'Points deducted from "Ease of fit" score when this tag is applied. Higher penalties indicate more difficult fitments. Maximum penalty is 10 points.',
      validation: (Rule) => Rule.min(0).max(10).precision(1),
      initialValue: 0,
    }),
  ],
  preview: {
    select: {
      title: 'name',
      displayName: 'displayName',
    },
    prepare({ title, displayName }) {
      return {
        title: displayName || title,
        subtitle: `Camber Tag: ${title}`,
      }
    },
  },
})
